import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppFilter } from "../../../models/app-filter.model";
import { AbSubIntegrador } from "app/abstract/full-pages/sub-integrador/sub-integrador.abstract";

@Injectable({ providedIn: 'root' })
export class SubIntegradorService extends AbSubIntegrador {

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public desativar(id: number) {
        return this.delete('admin/subintegradores/desativar/', id);
    }

    public getAllSubIntegradores(filter: AppFilter) {
        return this.get('admin/subintegradores/filter/' + filter.encode());
    }

    public saveSubIntegrador(form: any) {
        return this.save('admin/subintegradores/', form);
    }
}